import type { ProjectAccessRole } from "@/engine/types";

/** 기존 인력 역할에서 플랜 역할로 옮길 때의 제안. 소유자는 제안하지 않는다. */
export type SuggestedPlanRole = "관리자" | "편집자" | "기여자" | "뷰어";

/** §5.3.2. 직책(PM·PL이라는 말)은 받지 않는다. */
export function suggestPlanRole(accessRole: ProjectAccessRole): SuggestedPlanRole {
  if (accessRole === "admin" || accessRole === "pm") return "관리자";
  if (accessRole === "pl") return "편집자";
  if (accessRole === "member") return "기여자";
  return "뷰어";
}

/** 계정이 연결된 배정만 제안을 만든다. 권한은 바꾸지 않는다. */
export function suggestedPlanRoles(linked: boolean, accessRoles: ProjectAccessRole[]): SuggestedPlanRole[] {
  if (!linked) return [];
  const seen = new Set<SuggestedPlanRole>();
  for (const role of accessRoles) seen.add(suggestPlanRole(role));
  return [...seen];
}
